@if ({ bureaus: filterSet$ | async }; as state) {
  @if (!!activeBureau && bureauProfiles.length > 1) {
    <button tid="bureau-menu-button" [matMenuTriggerFor]="bureauMenu" class="menu-trigger" tabindex="0" (click)="focusSearch()">
      <span>{{ activeBureau.name }}</span>
      <i class="ph-light ph-caret-down"></i>
    </button>
    <form [formGroup]="formGroup">
      <mat-menu #bureauMenu tid="organisation-menu" class="context-menu">
        <app-search-input
          class="search-input"
          #searchInput
          formPropertyName="searchTerm"
          (click)="$event.stopPropagation()"
          (keydown)="$event.stopPropagation()"
          [autocomplete]="'off'"
          placeholder="Search"
          tabindex="0"
          [forContextMenu]="true"
        ></app-search-input>
        @for (bureau of state.bureaus; track bureau) {
          <button mat-menu-item (click)="changeBureau(bureau)" tabindex="0">
            {{ bureau.name }}
          </button>
        }
        @if (state.bureaus?.length === 0) {
          <app-body-md [bold]="true" id="no-results">No bureaux found</app-body-md>
        }
      </mat-menu>
    </form>
  }
  @if (!!activeBureau && bureauProfiles.length === 1) {
    <div class="selected-label" tid="single-bureau-label">
      <span>{{ activeBureau.name }}</span>
    </div>
  }
}
